<template>
  <v-col cols="6">
    <v-select
      v-model="monthName"
      :label="$t('time.month')"
      :items="monthNames"
    />
  </v-col>
  <v-col cols="6">
    <v-select
      v-model="year"
      :label="$t('time.year')"
      :items="years"
    />
  </v-col>
</template>
<script setup lang="ts">
const {  locale } = useI18n()
const  localePath = useLocalePath()

const props = defineProps({
  fromDate: {
    required: true,
    type: Date
  },
  toDate: {
    required: true,
    type: Date
  }
})
const monthNames = computed(() => {
  const date = new Date(2023,0,1)
  const months = []

  for (let i = 0; i < 12; i++) {
    date.setMonth(i)
    months.push({value: date.toLocaleDateString('en', {month: 'long'}).toLowerCase(),
      title: date.toLocaleDateString(locale.value, {month: 'long'})})
  }

  return months
})

const years = computed(() => {
  const years = [];
  for (
      let i = props.fromDate.getFullYear();
      i <= props.toDate.getFullYear();
      i++
  ) {
    years.push(i);
  }
  return years;

})
const route = useRoute();
const stateUrl = ref(route.params.stateUrl);
const placeUrl = ref(route.params.placeUrl);
const monthName = ref(route.params.month);
const year = ref(route.params.year || '') ;

watch(monthName, async (value) => {
  // update the monthNumber
  console.log("monthName changed to " + value);
  navigateTo(
      localePath(`/climate/summary/united-states/${stateUrl.value}/${placeUrl.value}/${monthName.value}/${year.value}`)
  );
});

watch(year, async (value) => {
  // update the monthNumber
  console.log("year changed to " + value);
  navigateTo(
      localePath(`/climate/summary/united-states/${stateUrl.value}/${placeUrl.value}/${monthName.value}/${year.value}`)
  );

});


</script>
<script lang="ts">
export default {
  name: 'SelectMonthYear'
}
</script>